import React, { MouseEventHandler, MouseEvent } from 'react';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import useDictionary from '@ui/hooks/useDictionary';
import { IColumn } from './useDeviceTelemetry';
import { emptyFn } from '@core/interfaces/emptyFn';

export interface IProps {
    currentColumn: IColumn;
    disableHide: boolean;
    hideMenu: (e: MouseEvent<HTMLLIElement>) => void;
    onUnsort: emptyFn;
    onAscSort: (field: string) => void;
    onDescSort: (field: string) => void;
    onHideCol: (field: string) => void;
}

const Component: React.FC<IProps> = ({
    currentColumn,
    disableHide,
    hideMenu,
    onUnsort,
    onAscSort,
    onDescSort,
    onHideCol,
}: IProps) => {
    const getWord = useDictionary();
    const field = currentColumn.field;

    const handleUnsortClick: MouseEventHandler<HTMLLIElement> = (e) => {
        onUnsort();
        hideMenu(e);
    };
    const handleAscSort: MouseEventHandler<HTMLLIElement> = (e) => {
        onAscSort(field);
        hideMenu(e);
    };
    const handleDescSort: MouseEventHandler<HTMLLIElement> = (e) => {
        onDescSort(field);
        hideMenu(e);
    };
    const handleHideCol: MouseEventHandler<HTMLLIElement> = (e) => {
        onHideCol(field);
        hideMenu(e);
    };

    const hideBtn = (
        <MenuItem className="column-menu__item" onClick={handleHideCol}>
            {getWord('hide')}
        </MenuItem>
    );

    return (
        <Box className="column-menu__wrap">
            <Box className="column-menu__list" component="ul">
                <MenuItem
                    className="column-menu__item"
                    onClick={handleUnsortClick}
                >
                    {getWord('unsort')}
                </MenuItem>
                <MenuItem className="column-menu__item" onClick={handleAscSort}>
                    {getWord('sortByAsc')}
                </MenuItem>
                <MenuItem
                    className="column-menu__item"
                    onClick={handleDescSort}
                >
                    {getWord('sortByDesc')}
                </MenuItem>
                {!disableHide && hideBtn}
            </Box>
        </Box>
    );
};

const ColumnMenuComponent = React.memo(Component);

export default ColumnMenuComponent;
